export default __webpack_public_path__ + "5dc6872cd9cbd36150d7cfe15ec98340.svg";